import React, { Fragment } from 'react';
import { Clock, Calendar, AlertCircle, FileX } from 'lucide-react';
import { SlideLayout } from './SlideLayout';
interface SlideProps {
  isActive: boolean;
  currentSlide: number;
  totalSlides: number;
  onNext: () => void;
  onPrev: () => void;
}
export function ProblemSlide(props: SlideProps) {
  return <SlideLayout {...props} title="The Assessment Bottleneck" subtitle="Creating high-quality assessments is a manual, error-prone, and incredibly slow process for institutions." data-id="element-118">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center mt-8" data-id="element-119">
        <div className="space-y-8" data-id="element-120">
          <div className="flex items-start gap-4 p-6 rounded-2xl bg-red-50 border border-red-100" data-id="element-121">
            <div className="p-3 bg-red-100 rounded-xl text-red-600" data-id="element-122">
              <Clock className="w-6 h-6" data-id="element-123" />
            </div>
            <div data-id="element-124">
              <h3 className="text-xl font-bold text-slate-900 mb-2" data-id="element-125">
                5 Weeks Average Turnaround
              </h3>
              <p className="text-slate-600" data-id="element-126">
                From content sourcing to final approved paper, the cycle
                consumes over a month of faculty time.
              </p>
            </div>
          </div>

          <div className="flex items-start gap-4 p-6 rounded-2xl bg-slate-50 border border-slate-100" data-id="element-127">
            <div className="p-3 bg-slate-200 rounded-xl text-slate-600" data-id="element-128">
              <FileX className="w-6 h-6" data-id="element-129" />
            </div>
            <div data-id="element-130">
              <h3 className="text-xl font-bold text-slate-900 mb-2" data-id="element-131">
                Fragmented Sources
              </h3>
              <p className="text-slate-600" data-id="element-132">
                Manually transcribing YouTube videos, scanning PDFs, and
                copy-pasting from PPTs is tedious.
              </p>
            </div>
          </div>

          <div className="flex items-start gap-4 p-6 rounded-2xl bg-slate-50 border border-slate-100" data-id="element-133">
            <div className="p-3 bg-slate-200 rounded-xl text-slate-600" data-id="element-134">
              <AlertCircle className="w-6 h-6" data-id="element-135" />
            </div>
            <div data-id="element-136">
              <h3 className="text-xl font-bold text-slate-900 mb-2" data-id="element-137">
                Inconsistent Quality
              </h3>
              <p className="text-slate-600" data-id="element-138">
                Manual formatting leads to errors, branding inconsistencies, and
                lack of standardization.
              </p>
            </div>
          </div>
        </div>

        <div className="relative h-full min-h-[400px] bg-slate-100 rounded-3xl p-8 flex flex-col items-center justify-center border border-slate-200" data-id="element-139">
          <div className="absolute top-8 right-8 text-slate-300" data-id="element-140">
            <Calendar className="w-32 h-32 opacity-20" data-id="element-141" />
          </div>

          <div className="text-center space-y-4 z-10" data-id="element-142">
            <div className="text-6xl font-bold text-slate-300 line-through decoration-red-500 decoration-4" data-id="element-143">
              35 Days
            </div>
            <div className="text-lg text-slate-500 font-medium" data-id="element-144">
              Average Time to Create & Finalize
            </div>
            <div className="w-full h-2 bg-slate-200 rounded-full mt-8 overflow-hidden" data-id="element-145">
              <div className="h-full bg-red-500 w-[90%] animate-pulse" data-id="element-146"></div>
            </div>
            <div className="text-xs text-slate-400 mt-2 text-right" data-id="element-147">
              90% Time Wasted on Logistics
            </div>
          </div>
        </div>
      </div>
    </SlideLayout>;
}